import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Price from 'shopper/components/Price/V2';

import { sendEvent } from 'lib/gtag';
import { getOfferImageLink, toStoreImageAltText } from 'lib/image';
import placeholder from 'lib/placeholder';
import { getUtmsFromSession } from 'lib/sessionStorage';
import { sendSupixEvent } from 'lib/supix';

import { useUser } from 'providers/UserProvider';

const OfferRowCard = ({
  gaEventCategory,
  offerCompareId,
  offerId,
  offerPrice,
  redirectUrl,
  storeImage,
  storeName,
}) => {
  const { LoggedInUser } = useUser();

  const onGoToStore = async () => {
    const utms = getUtmsFromSession();

    await sendSupixEvent('/ocout', {
      oid: offerId,
      ocid: offerCompareId,
      user_id: LoggedInUser?.userId,
      ...utms,
    });

    sendEvent({
      action: 'go_store_compare',
      category: gaEventCategory,
      label: offerCompareId,
    });
  };

  return (
    <article className="flex w-full flex-col justify-start gap-y-4 rounded-5 border border-rd-neutral-300 p-6 dark:border-neutral-low-200 md:flex-row md:items-center md:py-7">
      <div className="flex items-center gap-x-4">
        <Avatar
          description={toStoreImageAltText(storeName)}
          icon="store"
          size="size4"
          src={getOfferImageLink(storeImage, 50)}
        />
        <Heading as="h3" className="w-max" size="size5">
          {storeName}
        </Heading>
      </div>
      <Price
        className="md:ml-auto md:mr-6"
        primaryInfo={offerPrice}
        size="size2"
      />
      <Button
        as="a"
        className="justify-self-end md:w-48"
        href={redirectUrl}
        rel="noopener noreferrer"
        size="size2"
        target="_blank"
        full
        onClick={onGoToStore}
      >
        {placeholder('actions.goToStore')}
      </Button>
    </article>
  );
};

OfferRowCard.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  offerCompareId: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
  offerPrice: PropTypes.number.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  storeImage: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
};

export default OfferRowCard;
